<template>
  <RevDialog
    v-if="modalContent.title"
    :name="MODAL_NAMES.SWAP_REMOVE_CART"
    :title="modalContent.title"
    @close="handleClose"
  >
    <template #body>
      <p>
        {{ modalContent.body }}
      </p>
    </template>
    <template #footer="{ close }">
      <div class="flex flex-col gap-12">
        <RevButton
          data-test="swap-confirmation-remove"
          variant="primary"
          @click="handleRemove(close)"
        >
          {{ modalContent.removeLabel }}
        </RevButton>
        <RevButton variant="secondary" @click="handleCancel(close)">
          {{ modalContent.cancelLabel }}
        </RevButton>
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'

import { MODAL_NAMES } from '~/scopes/buyback/constants'

import translations from './SwapRemoveConfirmationCart.translations'

const props = defineProps<{
  price?: number
}>()

const emit = defineEmits<{
  remove: []
}>()

const eventName = ref('close_remove_tradein')

const i18n = useI18n()
const { trackClick } = useTracking()

const modalContent = computed(() => {
  return {
    title: i18n(translations.swapDeleteConfirmationCancelAnytimeTitle),
    body: i18n(translations.swapDeleteConfirmationCancelAnytimeBody),
    removeLabel: i18n(
      translations.swapDeleteConfirmationCancelAnytimeRemoveLabel,
    ),
    cancelLabel: i18n(translations.swapDeleteConfirmationCancel),
  }
})

const handleRemove = (close: () => void) => {
  eventName.value = 'confirm_remove_tradein'
  emit('remove')
  close()
}

const handleCancel = (close: () => void) => {
  eventName.value = 'cancel_remove_tradein'
  close()
}

const handleClose = () => {
  trackClick({
    name: eventName.value,
    zone: 'swap_cart',
    value: {
      swap_estimation: props.price,
    },
  })

  eventName.value = 'close_remove_tradein'
}
</script>
